import type { RootState } from "@src/store/rootState";
import { getExperienceProductsAction } from "./getExperienceProductsAction";

export const hasUnsavedProducts = (state: RootState) =>
  getExperienceProductsAction(state) !== undefined;
